"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ErrorsHelper;

var React = _interopRequireWildcard(require("react"));

var _Form = require("./Form");

var _formState = require("./formState");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function flattenErrors(errors) {
  var flatErrors = [];

  if (errors.client !== "pending") {
    flatErrors = flatErrors.concat(errors.client);
  }

  if (errors.external !== "unchecked") {
    flatErrors = flatErrors.concat(errors.external);
  }

  return flatErrors;
}

function ErrorsHelper(props) {
  var _getExtras = (0, _formState.getExtras)(props.link.formState),
      errors = _getExtras.errors,
      meta = _getExtras.meta;

  var flattened = flattenErrors(errors);
  var formContext = React.useContext(_Form.FormContext);
  var shouldShowErrors = formContext.shouldShowError(meta);
  return props.children({
    shouldShowErrors: shouldShowErrors,
    client: errors.client,
    external: errors.external,
    flattened: flattened
  });
}